import moment from "moment";

export function displayLocalDate(datetimeISO, opts) {
  if (!datetimeISO) return "";
  const timeFormat = opts && opts.hasOwnProperty('timeFormat') ? opts.timeFormat : "HH:mm:ss";
  const hasTime = datetimeISO.includes("T") || datetimeISO.split(" ").length >= 2;
  const utcDate = hasTime && !datetimeISO.includes("Z") ? `${datetimeISO}Z` : datetimeISO;
  return moment(new Date(utcDate)).format(`DD/MM/YYYY ${timeFormat}`);
}



// WEBPACK FOOTER //
// ./src/frontend/helpers/date.js